// Where Log in and Get SENfully lead once someone has access: this environment's SENfully app. CI resolves it at
// build time (deploy-senfully-website.yml), and `.env.development` points local work at the local SENfully.
// SENfully sends anyone not signed in straight to its own sign-in, so the root is all a Log in link needs.
export const SENFULLY_APP_URL = import.meta.env.VITE_SENFULLY_APP_URL ?? "";
